import { useState, useCallback, useEffect } from "react";
import moment from "moment";
import { useRevahaAuthorities } from "../../hooks";

const useOrderState = (initialOrder) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [noEndDate, setNoEndDate] = useState();
  const [disabled, setDisabled] = useState(true);
  const [clientCategories, setClientCategories] = useState([]);
  const [selectedClientCategory, setSelectedClientCategory] = useState(null);
  const [selectedClientTariffSymbol, setSelectedClientTariffSymbol] =
    useState(null);
  const [selectedRevahaAuthority, setSelectedRevahaAuthority] = useState(null);
  const revahaAuthorities = useRevahaAuthorities();

  useEffect(() => {
    if (initialOrder?.revaha_authority_id) {
      const authority = revahaAuthorities.find(
        (auth) => auth.id === initialOrder.revaha_authority_id
      );
      setSelectedRevahaAuthority(authority || null);
    } else {
      setSelectedRevahaAuthority(null);
    }
  }, [initialOrder, revahaAuthorities]);

  // Function to handle changes in date fields
  const handleDateFieldChanges = useCallback(
    (changedValues, allValues, form, activeOrder) => {
      const shouldResetEffectiveFrom =
        changedValues["closed_previous_order_id"] === true &&
        (isBeforeStartDate(
          allValues.effective_from,
          activeOrder.effective_from
        ) ||
          isAfterEndDate(allValues.effective_from, activeOrder.effective_to));

      if (shouldResetEffectiveFrom) {
        form.setFieldsValue({ effective_from: null });
      }

      if (changedValues["effective_from"] === null) {
        form.setFieldsValue({ effective_to: null });
      }
    },
    []
  );

  const toggleDraggable = useCallback(() => {
    setDisabled((prev) => !prev);
  }, []);

  // Helper functions for date comparison
  const isBeforeStartDate = (currentDate, startDate) =>
    moment(currentDate).isBefore(moment(startDate).endOf("day"));

  const isAfterEndDate = (currentDate, endDate) =>
    endDate &&
    moment(currentDate).isAfter(moment(endDate).add(1, "days").endOf("day"));

  return {
    // State
    startDate,
    endDate,
    noEndDate,
    disabled,
    clientCategories,
    selectedClientCategory,
    selectedClientTariffSymbol,
    selectedRevahaAuthority,
    // Setters
    setStartDate,
    setEndDate,
    setNoEndDate,
    setDisabled,
    setClientCategories,
    setSelectedClientCategory,
    setSelectedClientTariffSymbol,
    setSelectedRevahaAuthority,
    // Functions
    handleDateFieldChanges,
    toggleDraggable,
  };
};

export default useOrderState;
